export default {
  get(route) {
    // get via fetch api
    return new Promise((resolve) => {
      fetch(route)
        .then((response) => {
          console.log('response.status =', response.status) // response.status = 200
          return response.json()
        })
        .then((data) => {
          resolve(data)
        })
        .catch(function (error) {
          // handle error
          console.log(error)
          resolve(false)
        })
    })
  },

  post(route, formData) {
    return new Promise((resolve) => {
      // fetch api POST
      fetch(route, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          resolve(data)
        })
        .catch(function (error) {
          // handle error
          console.log(error)
          resolve(false)
        })
    })
  },
}
